import type { TraderProfile as MesaTraderProfile } from '@/types/api/legacy-trader-profile'

import React from 'react'

import { ButtonVariant } from '@/components/atomic/button'
import { ButtonSize } from '@/components/atomic/button/variants'
import Icon, { PhosphorIconName } from '@/components/atomic/icon'
import ButtonRequiringTraderProfile from '@/trading/trade-desk-blotter/button-requiring-trader-profile'
import { cn } from '@/utils/shadcn/utils'

interface BidActionColumnProps {
  isDisabled: boolean
  borderStatus: boolean
  isHighlight: boolean
  rowHeight: number
  onHitBid: (traderProfile: MesaTraderProfile) => void
  isButtonDisabled: boolean
  isLoading: boolean
  showActionButtonsOnAllRows: boolean
  isFirstValidBid: boolean
  renderOnLeft?: boolean
  // biome-ignore lint/suspicious/noExplicitAny: Bulk suppression as part of biome migration
  CellComponent: React.ComponentType<any>
}

const BidActionColumn = React.memo<BidActionColumnProps>(
  ({
    isDisabled,
    borderStatus,
    isHighlight,
    rowHeight,
    onHitBid,
    isButtonDisabled,
    isLoading,
    showActionButtonsOnAllRows,
    isFirstValidBid,
    renderOnLeft = false,
    CellComponent,
  }) => (
    <CellComponent
      hasBorder={(!isHighlight || isDisabled) && borderStatus}
      className={cn('p-0')}
      height={rowHeight}
    >
      {isDisabled ? (
        <div
          className={cn(
            'flex items-center h-8 w-[36px] m-auto',
            renderOnLeft ? 'justify-start mr-2' : 'justify-end mr-2',
          )}
        >
          <Icon
            iconName={PhosphorIconName.ProhibitIcon}
            size="medium"
            isPhosphor
          />
        </div>
      ) : (
        <ButtonRequiringTraderProfile
          variant={ButtonVariant.Primary}
          size={ButtonSize.Small}
          label="Hit"
          onClick={onHitBid}
          disabled={isButtonDisabled}
          isLoading={isLoading}
          className={cn(
            'transition-opacity m-auto',
            renderOnLeft ? 'ml-1' : 'mr-1',
            showActionButtonsOnAllRows || isFirstValidBid ? '' : 'hidden',
          )}
        />
      )}
    </CellComponent>
  ),
)
BidActionColumn.displayName = 'BidActionColumn'

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default BidActionColumn
